import React from 'react';
import './ImageBox.css';

const ImageBox = ({ image, onReplace }) => {
    return (
        <div className="image-box">
            <img 
                src={image.url} 
                alt={image.name} 
                className="image-preview"
            />
            <div className="image-details">
                <p><strong>Name:</strong> {image.name}</p>
                <p><strong>Dimensions:</strong> {image.dimensions.width} x {image.dimensions.height} px</p>
            </div>
            <button className="replace-image-button" onClick={onReplace}>
                Replace Image
            </button>
        </div>
    );
};

export default ImageBox; 